import './styles/index.css';
import { initApp } from './js/app.js';

initApp();
